import { handleAjaxError } from "./handleAjaxError";
import { renderMessage } from "./renderMessage";
import { submitChatMessages } from "./submitChatMessages";
import { updateCredits } from "./updateCredits";
import { appendMessageLoader } from "./appendMessageLoader";
import { scrollToChatBottom } from "./scrollToChatBottom";

export function recordAudio() {
  class VoiceRecorder {
    constructor() {
      this.waveContainerHeight = 30;

      this.audioBlob = null;
      this.audioURL = null;
      this.isRecording = false;

      // References to buttons
      this.startRef = $(".g-chatform-audio-recorder-start");
      this.stopRef = $(".g-chatform-audio-recorder-stop");
      this.previewRef = $(".g-chatform-audio-recorder-preview");
      this.deleteRef = $(".g-chatform-audio-recorder-delete");
      this.submitRef = $(".g-chatform-audio-recorder-submit");
      this.playRef = $(".g-chatform-audio-recorder-play");
      this.resetRef = $(".g-chatform-audio-recorder-reset");

      // Button event handlers
      this.startRef.on("click", this.startRecording.bind(this));
      this.stopRef.on("click", this.stopRecording.bind(this));
      this.deleteRef.on("click", this.deleteRecording.bind(this));
      this.submitRef.on("click", this.submitRecording.bind(this));
      this.previewRef.on("click", this.previewRecording.bind(this));
      this.playRef.on("click", this.playRecording.bind(this));
      this.resetRef.on("click", this.resetRecording.bind(this));

      if (!this.startRef.length) {
        return;
      }

      // Initialize WaveSurfer and plugins
      this.initRecordingWaveSurfer();
    }

    initRecordingWaveSurfer(
      container = "#g-chatform-audio-recorder-waveform-initial"
    ) {
      if (
        typeof WaveSurfer === "undefined" ||
        typeof WaveSurfer.Record === "undefined"
      ) {
        console.error(
          "WaveSurfer or WaveSurfer.Record is not loaded. Ensure scripts are enqueued and loaded correctly."
        );
        return;
      }

      // Create the WaveSurfer instance
      this.waveSurfer = WaveSurfer.create({
        container: container,
        waveColor: growtypeChatAudioWaveColor,
        progressColor: growtypeChatAudioProgressColor,
        responsive: true,
        height: this.waveContainerHeight,
      });

      const recordPlugin = WaveSurfer.Record.create({
        renderRecordedAudio: true,
        scrollingWaveform: false,
        continuousWaveform: true,
        continuousWaveformDuration: 30,
      });

      let record = this.waveSurfer.registerPlugin(recordPlugin);

      record.on("record-end", (blob) => {
        this.handleRecording(blob);
      });
    }

    handleRecording(blob) {
      this.audioBlob = blob;
      this.audioURL = URL.createObjectURL(blob);
    }

    startRecording(
      element,
      recordingContainerSelector = "#g-chatform-audio-recorder-waveform-initial"
    ) {
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        $("body").addClass("g-chatform-is-recording");
        $(".g-chatform-audio-recorder-play").addClass("is-active");

        let $this = this;
        let formData = new FormData();
        formData.append("action", "growtype_chat_start_audio_recording");
        formData.append("nonce", growtype_chat_ajax.nonce);

        /**
         * Analytics
         */
        if (typeof growtypeAnalyticsCapture === "function") {
          growtypeAnalyticsCapture(
            "growtype_analytics_growtype_chat_action_clicked",
            {
              title: "record_message",
            }
          );
        }

        $.ajax({
          url: growtype_chat_ajax.url,
          type: "POST",
          data: formData,
          processData: false,
          contentType: false,
          success: function (response) {
            navigator.mediaDevices
              .getUserMedia({ audio: true })
              .then((stream) => {
                if ($this.waveSurfer) {
                  $this.waveSurfer.destroy();
                  $this.initRecordingWaveSurfer(recordingContainerSelector);
                }

                const recordPlugin = $this.waveSurfer.plugins[0];
                if (!recordPlugin) {
                  console.error("Record plugin is not registered.");
                  return;
                }

                $this.isRecording = true;

                $(".g-chatform-audio-recorder-recording").fadeIn();

                recordPlugin.startRecording();

                // 🎤 Live browser SpeechRecognition disabled —
                // audio is instead sent to the server for Whisper transcription on submit.
              })
              .catch((error) => {
                console.error("Microphone access denied:", error);
                alert(
                  "Microphone access denied. Please enable it in your browser settings."
                );
              });
          },
          error: function (response) {
            $this.stopRecording();
            handleAjaxError(response);
          },
        });
      } else {
        console.error("getUserMedia is not supported in this browser.");
        alert("Your browser does not support microphone access.");
      }
    }

    startSpeechRecognition() {
      // Initialize SpeechRecognition
      this.recognition = new (window.SpeechRecognition ||
        window.webkitSpeechRecognition)();
      this.recognition.lang = "en-US";
      this.recognition.interimResults = true;

      this.recognition.onresult = (event) => {
        let interimTranscript = "";
        for (let i = event.resultIndex; i < event.results.length; ++i) {
          if (event.results[i].isFinal) {
            interimTranscript += event.results[i][0].transcript + " ";
          }
        }

        this.fullTranscript += interimTranscript;

        // Insert the full text into the input field
        const inputField = document.querySelector(".g-chatform-text-input");
        if (inputField) {
          inputField.value = this.fullTranscript.trim();
        }
      };

      this.recognition.onerror = (event) => {
        // alert('Speech recognition error. Please try again.');
        console.error("Speech recognition error:", event.error);
      };

      this.recognition.onend = () => {
        if (this.isRecording) {
          this.startSpeechRecognition();
        }
      };

      this.recognition.start();
    }

    stopRecording(showPreview = true) {
      $("body").removeClass("g-chatform-is-recording");
      $(".g-chatform-audio-recorder-play").removeClass("is-active");

      if (this.recognition) {
        setTimeout(() => {
          this.recognition.abort();
          console.log("Speech recognition instance aborted.");
        }, 1000);
      }

      if (this.isRecording) {
        this.isRecording = false;

        const recordPlugin = this.waveSurfer.plugins[0];

        if (recordPlugin) {
          recordPlugin.stopRecording();
        }

        if (showPreview) {
          $(".g-chatform-audio-recorder-recording").fadeOut();
          $(".g-chatform-audio-recorder-results").fadeIn();

          setTimeout(() => {
            this.previewRecording();
          }, 500);
        }
      }
    }

    deleteRecording() {
      if (this.isRecording) {
        this.stopRecording(false);
      }

      if (this.audioURL) {
        URL.revokeObjectURL(this.audioURL);
        this.audioURL = null;
        this.audioBlob = null;
      }

      if (this.waveSurfer) {
        this.waveSurfer.destroy();
        this.initRecordingWaveSurfer();
      }

      $(".g-chatform-audio-recorder-recording").fadeOut();
      $(".g-chatform-audio-recorder-results").fadeOut();
    }

    previewRecording() {
      if (this.audioURL) {
        if (this.waveSurfer && this.waveSurfer.isPlaying()) {
          this.waveSurfer.stop(); // Stop playback
          return; // Exit to stop playback without restarting
        }

        this.initPreviewWaveSurfer();
      }
    }

    initPreviewWaveSurfer() {
      if (this.waveSurfer) {
        this.waveSurfer.destroy();
      }

      // Recreate the WaveSurfer instance for playback visualization
      this.waveSurfer = WaveSurfer.create({
        container: "#g-chatform-audio-recorder-waveform-results",
        waveColor: growtypeChatAudioWaveColor,
        progressColor: growtypeChatAudioProgressColor,
        responsive: true,
        height: this.waveContainerHeight,
      });

      // Load the recorded audio
      this.waveSurfer.load(this.audioURL);

      // Play the audio once it is ready
      this.waveSurfer.on("ready", () => {
        // this.waveSurfer.play();
      });

      // Log when playback finishes
      this.waveSurfer.on("finish", () => {
        $(".g-chatform-audio-recorder-play").removeClass("is-active");
      });
    }

    playRecording() {
      if (this.isRecording) {
        $(".g-chatform-audio-recorder-play").removeClass("is-active");
        this.stopRecording();

        // Wait briefly to ensure recording is processed
        setTimeout(() => {
          this.previewRecording();
        }, 500); // Adjust the delay as necessary
      } else if (this.waveSurfer) {
        if (this.waveSurfer.isPlaying()) {
          $(".g-chatform-audio-recorder-play").removeClass("is-active");
          this.waveSurfer.pause();
        } else {
          $(".g-chatform-audio-recorder-play").addClass("is-active");
          this.waveSurfer.play();
        }
      } else {
        console.error("Recording instance is not initialized.");
      }
    }

    submitRecording() {
      if (this.isRecording) {
        this.stopRecording(false);
      }

      setTimeout(() => {
        this.saveRecording();
      }, 500);
    }

    saveRecording() {
      if (!this.audioBlob) {
        this.deleteRecording();
        return;
      }

      const chatForm = this.startRef.closest(".g-chatform");
      const sessionToken = chatForm.attr("data-session-token");
      const userToken = chatForm.attr("data-user-token");

      const adminMessageTemplate = appendMessageLoader(chatForm);

      scrollToChatBottom(200, true);

      const formData = new FormData();
      formData.append("action", "save_recorded_audio");
      formData.append("nonce", growtype_chat_ajax.nonce);
      formData.append("audio_data", this.audioBlob);
      formData.append("audio_hash", this.generateUniqueHash());

      formData.append(
        "user",
        JSON.stringify({
          token: userToken,
        })
      );

      formData.append(
        "session",
        JSON.stringify({
          token: sessionToken,
        })
      );

      $.ajax({
        url: growtype_chat_ajax.url,
        type: "POST",
        data: formData,
        processData: false,
        contentType: false,
        success: (response) => {
          renderMessage(chatForm, response, adminMessageTemplate);

          let transcribedMessages = [];
          response["data"]["response_messages"].map(function (element, index) {
            const text = element["transcribed_content"];
            if (text && text.trim()) {
              transcribedMessages.push({
                value: text,
                skip_question_preview: true,
                skip_saving: true,
              });
            }
          });

          /**
           * Update credits
           */
          updateCredits(response.data.existing_credits);

          // Only auto-submit if there is actual transcribed content.
          if (transcribedMessages.length > 0) {
            setTimeout(function () {
              const userMessageTemplate = appendMessageLoader(chatForm, "user");

              submitChatMessages(transcribedMessages, chatForm);
            }, 500);
          }
        },
        error: function (response) {
          adminMessageTemplate.remove();
          handleAjaxError(response);
        },
      });

      this.deleteRecording();
    }

    generateUniqueHash() {
      return `${Date.now()}-${Math.random().toString(36).substring(2, 15)}`;
    }

    resetRecording() {
      if (this.waveSurfer) {
        this.startRecording(
          null,
          "#g-chatform-audio-recorder-waveform-results"
        );
      }
    }
  }

  // Create the recorder instance
  window.voiceRecorder = new VoiceRecorder();
}
